import React from 'react';
import { Box, Button, Dialog, Typography } from '@mui/material';
import { COLORS } from '../theme';

type Props = {
  open: boolean;
  /** `true` when the cashier asked for a receipt. Phase 1 records the
   *  answer and nothing else — no printing, no email. */
  onAnswer: (wantsReceipt: boolean) => void;
};

const ReceiptDialog: React.FC<Props> = ({ open, onAnswer }) => (
  <Dialog open={open} maxWidth="sm" fullWidth>
    <Box sx={{ p: 3 }}>
      <Typography
        sx={{ textAlign: 'center', fontWeight: 700, fontSize: '1.5rem', mb: 3 }}
      >
        Receipt for this sale?
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          variant="outlined"
          onClick={() => onAnswer(false)}
          sx={{
            flex: 1,
            height: 100,
            fontSize: '1.2rem',
            fontWeight: 700,
            borderWidth: 2,
            borderColor: COLORS.border,
            color: COLORS.text,
          }}
        >
          NO RECEIPT
        </Button>
        <Button
          variant="contained"
          onClick={() => onAnswer(true)}
          sx={{ flex: 1, height: 100, fontSize: '1.2rem', fontWeight: 700 }}
        >
          RECEIPT
        </Button>
      </Box>
    </Box>
  </Dialog>
);

export default ReceiptDialog;
